/* eslint-disable import/no-unresolved */
import styled from 'styled-components';
import { Swiper } from 'swiper/react';

import 'swiper/css';
import 'swiper/css/navigation';

export const DesktopFeaturesWrapper = styled.div`
  display: flex;
  gap: 4px;
  width: 440px;
  background-color: ${({ theme }) => theme.palette.NL20};
  padding: 8px;
  justify-content: space-between;
  align-items: flex-end;
  align-self: stretch;
  border-radius: 8px;
  height: 39px;
`;

export const DesktopFeatureGroup = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  flex: 1 0 0;
  align-self: stretch;
  max-width: 399px;
  over-flow: hidden;
`;

export const ItemContainer = styled.div`
  display: flex;
  gap: 4px;
  line-height: 18px;
`;

export const ShowMoreContainer = styled.div`
  background-color: ${({ theme }) => theme.palette.NL0};
  border-radius: 4px;
  display: flex;
  padding: 4px;
  flex-direction: column;
  justify-content: flex-end;
  align-items: center;
  gap: 10px;
  line-height: 13px;
  height: 23px;
`;

export const TooltipItemsContainer = styled.div`
  background-color: ${({ theme }) => theme.palette.NL20};
  border-radius: 4px;
  padding: 4px;
  max-height: 180px;
  overflow: auto;
`;

export const MobileFeaturesContainer = styled.div`
  height: 40px;
  padding: 8px;
  border-radius: 8px;
  background-color: ${({ theme }) => theme.palette.NL20};
  width: 100%;
  margin-top: 12px;
`;

export const StyledSwiper = styled(Swiper)`
  width: 100%;
  .swiper-slide {
    height: 24px;
    width: auto;
    box-sizing: border-box;
  }
`;

export const ItemContainerMobile = styled.div`
  display: flex;
  gap: 4px;
  line-height: 24px;
  height: 100%;
`;
